import(/* webpackMode: "eager" */ "/home/runner/work/website/website/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/website/website/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/website/website/src/app/blogs/[...slug]/sideNavigator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar","AvatarImage","AvatarFallback"] */ "/home/runner/work/website/website/src/components/ui/avatar.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/website/website/src/styles/mdx.css");
